import { useTranslation } from '@framework/i18n';
import { ItaliaButton } from '../components/ItaliaButton';
import { getIdpAuthUrl } from '../hooks/useGetIdpAuthUrlFn';

export interface EidasLoginButtonProps {
  resolvePublicUrl: (path: string) => string;
  fullWidth?: boolean;
}

/**
 * Pulsante eIDAS
 */
export function EidasLoginButton(props: EidasLoginButtonProps) {
  const { resolvePublicUrl, fullWidth } = props;
  const { t } = useTranslation();

  const redirectUrl = getIdpAuthUrl({
    idpMethod: 'SPID',
    resolvePublicUrl,
    entityId: 'eidas',
  });

  return (
    <ItaliaButton
      href={redirectUrl}
      style={fullWidth ? { width: '100%' } : undefined}
      image={require('./img/ficep-it-eidas-db.svg')}
      text={t('user.login.eidas-button', 'Login with eIDAS')}
    />
  );
}
